import datapoints from '../datapoints';
import { onSingleMailItemSelected } from 'owa-mail-actions/lib/mailListActions';
import { singleSelectRow, toggleSelectRow, rangeSelectRow } from 'owa-mail-actions';
import { getIsSearchTableShown } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import { action } from 'satcheljs/lib/legacy';
var onMailListItemClickHandlerActionName = 'onMailListItemClickHandler';
export { onMailListItemClickHandlerActionName };
/**
 * A handler for events created by user clicking mail list item(s)
 * @param evt the mouse event
 * @param selectionSource the source of event
 * @param rowKey the given conversation rowKeys
 * @param tableViewId - the table view id that this conversation belong to (or null if we don't care)
 * @returns a promise with boolean value based on if we have handled the event here
 */
export default action(onMailListItemClickHandlerActionName, datapoints.mailListItemClickedDatapoint)(function onMailListItemClickHandler(evt, selectionSource, rowKey, tableViewId) {
    evt.stopPropagation();
    var isCtrlKeyDown = evt.ctrlKey;
    var tableView = listViewStore.tableViews.get(tableViewId);
    var isShiftCtrlHandled = false;
    var promise = Promise.resolve();
    var isExplicitSelect;
    // The promise returns false if we do not handle the click here
    // Otherise promise returns true meaning we have captured the click event here
    if (evt.shiftKey) {
        rangeSelectRow(tableView, rowKey, selectionSource, isCtrlKeyDown /* isCtrlSelect */);
        isShiftCtrlHandled = true;
    }
    else if (isCtrlKeyDown ||
        selectionSource === MailListItemSelectionSource.MailListItemCheckbox) {
        // Selection source should always be checkbox for toggle behavior
        toggleSelectRow(tableView, rowKey, true /* isUserNavigation */, selectionSource);
        isShiftCtrlHandled = true;
    }
    else if (selectionSource === MailListItemSelectionSource.MailListItemRichPreview) {
        // Select the item if user has clicked on the attachment preview
        singleSelectRow(tableView, rowKey, true /* isUserNavigation */, selectionSource);
    }
    else if (selectionSource === MailListItemSelectionSource.MailListItemTwisty) {
        singleSelectRow(tableView, rowKey, true /* isUserNavigation */, selectionSource);
        isExplicitSelect = true;
    }
    else {
        singleSelectRow(tableView, rowKey, true /* isUserNavigation */, selectionSource);
        isExplicitSelect = true;
    }
    if (isExplicitSelect && !getIsSearchTableShown()) {
        onSingleMailItemSelected();
    }
    return promise.then(function () { return isShiftCtrlHandled; });
});
//# sourceMappingURL=onMailListItemClickHandler.js.map